import * as moment from "moment";

export const formatDate = (timestamp: number, format = "YYYY-MM-DD HH:mm:ss UTC") => {
    if (!timestamp) {
        return "N/A"
    }
    return moment(timestamp).tz("UTC").format(format);
}

export class DateUtil {
    static getUtcDateString() {
        return formatDate(moment().valueOf());
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/util/date.ts